/****************************************************
 * Module Name:  cancelSaleModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React from "react";
import { Modal } from "react-bootstrap";
import { Button, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import Constants from "../../utility/constants";
import ClearIcon from "@mui/icons-material/Clear";

export default function CancelSaleModal({
    show,
    setShow,
    handleSave,
    loading
}) {
    const saveHandler = () => {
        if (handleSave) {
            handleSave();
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    return (
        <Modal
            show={show}
            onHide={() => handleClose()}
            backdrop="static"
            keyboard={true}
            centered
            enforceFocus={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <img
                        src={logo}
                        height="40pt"
                        width="40pt"
                        alt={Constants.COMPANY_SITE}
                    />
                    &nbsp;&nbsp;
                    Cancel sale
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Typography variant="h5">
                    Are you sure you want to cancel these stone(s) sale ?
                </Typography>
            </Modal.Body>
            <Modal.Footer>
                <LoadingButton
                    variant="contained"
                    onClick={saveHandler}
                    sx={{ mr: 3 }}
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<ClearIcon />}
                >
                    Cancel Sale
                </LoadingButton>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleClose}
                    sx={{ mr: 2 }}
                    disabled={loading}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}